import React, { useState, useRef, useEffect } from "react";
import "./imageGrid.css";
import { axios } from "../../utils/axios";
import TripModal from "../../components/TripModel";
import { DotsLoader } from "../../components/DotsLoader";

const Explore = () => {
  const [open, setOpen] = useState(false);
  const [exploreTrips, setExploreTrips] = useState([]);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const loader = useRef(null);

  const getExploreTrips = (currentPage) => {
    axios
      .get(
        process.env.REACT_APP_BACKEND +
          `exploretrips/getexploretrips?page=${currentPage}&limit=18`
      )
      .then((resp) => {
        const newTrips = resp.data.data?.trips;
        const filteredData = newTrips.filter(
          (item) =>
            item.itinerary &&
            item.itinerary[0] &&
            item.itinerary[0].tripItinerary &&
            item.itinerary[0].tripItinerary.length > 0
        );
        console.log(filteredData);
        const gridAreas = ["a", "b", "c", "d", "e", "f"];

        const updatedFilteredData = filteredData.map((trip, index) => {
          const currentCount = exploreTrips.length;

          const gridAreaIndex = (currentCount + index) % gridAreas.length;
          const assignedGridArea = gridAreas[gridAreaIndex];
          return {
            ...trip,
            gridArea: assignedGridArea,
          };
        });

        setExploreTrips((prevTrips) => [...prevTrips, ...updatedFilteredData]);
        setPage(currentPage + 1);
        setHasMore(currentPage < resp.data.data.totalPages);
      })
      .catch((err) => console.log(err));
  };

  const handleOpenModal = (item) => {
    setOpen(true);
    setSelectedTrip(item);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedTrip(null);
  };

  useEffect(() => {
    if (!hasMore) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          getExploreTrips(page);
        }
      },
      { threshold: 1 }
    );

    if (loader.current) {
      observer.observe(loader.current);
    }

    return () => observer.disconnect();
  }, [page, hasMore]);

  return (
    <div className="bgsearch">
      <div className="container p-5 ">
        <h1 className="t-center my-4">
          Discover your{" "}
          <span style={{ color: "var(--yellow-color)" }}>Trip</span>
        </h1>
        <div className="custom-gallery-grid">
          {exploreTrips.map((ext, index) => (
            <div
              key={index}
              className={`gallery-item  ${ext?.gridArea}`}
              style={{
                background: `url(${ext?.image})`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                borderRadius: "6px",
              }}
            >
              <div className="gradient-overlay">
                <h2 className="mx-auto p-0 mt-2">{ext?.name}</h2>
                <div className="py-2 px-3" style={{ textAlign: "end" }}>
                  <button
                    className="btn-contained"
                    onClick={() => handleOpenModal(ext)}
                  >
                    Explore
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <TripModal
          selectedTrip={selectedTrip}
          open={open}
          handleClose={handleClose}
        />
      </div>
      {hasMore && (
        <div ref={loader} style={{ height: "50px", textAlign: "center" }}>
          <DotsLoader />
        </div>
      )}
    </div>
  );
};

export default Explore;
